// RBAC role that confers administrator privileges upon users of any account
export const SYSTEM_ADMIN = 'system-admin';

// RBAC roles that are system-wide in scope, ie not restricted to the user's account
export const systemRoles = ['account-viewer'];

export const SYSTEM_COMPONENTS = ['services', 'feeds'] as const;

export const SYSTEM_STATUS_ITEMS = ['system', ...SYSTEM_COMPONENTS] as const;
